import React, { useState, useEffect } from "react";
import "../Styles/Memberboard.css";
import { RiCloseLargeFill } from "react-icons/ri";
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Addmember from "./Addmember";
import ApiService from "../nhrc_apis/ApiService";

function Boardmembers() {
  const [boardmembers, setBoardMembers]   = useState([]);
  const [viewEmployee, setViewEmployee]   = useState(false);
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [editData, setEditData]           = useState({});
  const [showAddmember, setShowAddmember] = useState(false);
  const [loading, setLoading]             = useState(false);
  const [pageLoading, setPageLoading]     = useState(true);

  // ─── FETCH ALL ON MOUNT ───────────────────────────────
  useEffect(() => {
    fetchBoardMembers();
  }, []);

  // ─── REFETCH AFTER ADD MODAL CLOSES ──────────────────
  useEffect(() => {
    if (!showAddmember) {
      fetchBoardMembers();
    }
  }, [showAddmember]);

  // ─── FETCH ALL BOARD MEMBERS ──────────────────────────
  const fetchBoardMembers = async () => {
    try {
      setPageLoading(true);
      const response = await ApiService.BoardMembersAPI.getAllBoardMembers();
      const data = response.data;

      console.log("BOARD MEMBERS RESPONSE:", data);

      // ✅ handles any response shape
      const normalized =
        Array.isArray(data)
          ? data
          : data?.board_members ||
            data?.members       ||
            data?.data          ||
            data?.content       ||
            [];

      setBoardMembers(normalized);
    } catch (err) {
      console.error("Fetch board members error:", err);
      toast.error("Failed to load board members!");
    } finally {
      setPageLoading(false);
    }
  };

  // ─── OPEN ADD MODAL ───────────────────────────────────
  const handleShowAddmember = () => setShowAddmember(true);
  const handleCloseAddmember = () => setShowAddmember(false);

  // ─── OPEN VIEW / EDIT POPUP ───────────────────────────
  const openDetails = async (member) => {
    try {
      const response = await ApiService.BoardMembersAPI.getBoardMember(member.id);
      const data = response.data;

      console.log("GET MEMBER BY ID:", data);

      setSelectedBoard(data);
      setEditData({
        full_name:          data.full_name          || "",
        professional_title: data.professional_title || "",
        current_position:   data.current_position   || "",
        photo_url:          data.photo_url          || "",
        linkedin_url:       data.linkedin_url       || "",
        twitter_url:        data.twitter_url        || "",
        facebook_url:       data.facebook_url       || "",
      });
      setViewEmployee(true);
    } catch (err) {
      console.error("Get board member error:", err);
      toast.error("Failed to load member details!");
    }
  };

  // ─── CLOSE POPUP ─────────────────────────────────────
  const closeDetails = () => {
    setViewEmployee(false);
    setSelectedBoard(null);
    setEditData({});
  };

  // ─── HANDLE INPUT CHANGE ──────────────────────────────
  const handleChange = (key, value) => {
    setEditData((prev) => ({ ...prev, [key]: value }));
  };

  // ─── UPDATE BOARD MEMBER ──────────────────────────────
  const saveDetails = async () => {
    if (!editData.full_name?.trim()) {
      toast.error("Full name cannot be empty!");
      return;
    }
    try {
      setLoading(true);
      const payload = {
        full_name:          editData.full_name.trim(),
        professional_title: editData.professional_title.trim(),
        current_position:   editData.current_position.trim(),
        photo_url:          editData.photo_url.trim(),
        linkedin_url:       editData.linkedin_url.trim(),
        twitter_url:        editData.twitter_url.trim(),
        facebook_url:       editData.facebook_url.trim(),
      };

      await ApiService.BoardMembersAPI.updateBoardMember(selectedBoard.id, payload);

      // ✅ update local state instantly
      setBoardMembers((prev) =>
        prev.map((m) =>
          m.id === selectedBoard.id ? { ...m, ...payload } : m
        )
      );
      toast.success("Board member updated successfully!");
      closeDetails();
    } catch (err) {
      console.error("Update board member error:", err);
      const msg = err?.response?.data?.message || err?.response?.data?.detail;
      toast.error(msg || "Failed to update member. Try again!");
    } finally {
      setLoading(false);
    }
  };

  // ─── DELETE BOARD MEMBER ──────────────────────────────
  const handleDelete = async (member) => {
    if (!window.confirm(`Are you sure you want to delete "${member.full_name}"?`)) return;
    try {
      setLoading(true);
      await ApiService.BoardMembersAPI.deleteBoardMember(member.id);
      setBoardMembers((prev) => prev.filter((m) => m.id !== member.id));
      toast.success("Board member deleted successfully!");
    } catch (err) {
      console.error("Delete board member error:", err);
      toast.error("Failed to delete member. Try again!");
    } finally {
      setLoading(false);
    }
  };

  // ─── RENDER ───────────────────────────────────────────
  return (
    <div className="board-side-container">
      <ToastContainer autoClose={2000} position="top-right" theme="colored" />

      <div className="board-side-header-bar">
        <h2>NHRC Our Board Members</h2>
      </div>

      <div className="board-side-action-bar">
        <button className="board-side-show-btn" onClick={handleShowAddmember}>
          Add Member +
        </button>
      </div>

      <div className="board-side-table-container">
        {pageLoading ? (
          <p style={{ textAlign: "center", padding: "20px" }}>
            Loading board members...
          </p>
        ) : (
          <table className="board-side-table">
            <thead>
              <tr>
                <th></th>
                <th>Member Name</th>
                <th>Professional Title</th>
                <th>Current Position</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {boardmembers.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", padding: "25px" }}>
                    No board members found. Click "Add Member +" to add new members.
                  </td>
                </tr>
              ) : (
                boardmembers.map((board) => (
                  <tr key={board.id}>

                    {/* ── Photo ── */}
                    <td>
                      {board.photo_url ? (
                        <img
                          src={board.photo_url}
                          alt={board.full_name}
                          style={{
                            width:        "40px",
                            height:       "40px",
                            borderRadius: "50%",
                            objectFit:    "cover",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width:           "40px",
                            height:          "40px",
                            borderRadius:    "50%",
                            background:      "#e0e0e0",
                            display:         "flex",
                            alignItems:      "center",
                            justifyContent:  "center",
                            fontSize:        "16px",
                            fontWeight:      "bold",
                            color:           "#666",
                          }}
                        >
                          {board.full_name?.charAt(0)?.toUpperCase() || "?"}
                        </div>
                      )}
                    </td>

                    <td>{board.full_name}</td>
                    <td>{board.professional_title}</td>
                    <td>{board.current_position}</td>

                    <td className="d-flex gap-2">
                      <button
                        className="board-side-view-btn"
                        onClick={() => openDetails(board)}
                      >
                        View / Edit
                      </button>
                      <button
                        className="board-side-delete-btn"
                        onClick={() => handleDelete(board)}
                        disabled={loading}
                      >
                        Delete
                      </button>
                    </td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* ── Add Member Modal ── */}
      <Modal
        show={showAddmember}
        onHide={handleCloseAddmember}
        centered
        size="lg"
        backdrop="static"
        className="membership-modal"
      >
        <Modal.Header className="border-0 p-0">
          <Addmember
            show={showAddmember}
            onClose={handleCloseAddmember}
          />
        </Modal.Header>
      </Modal>

      {/* ── View / Edit Popup ── */}
      {viewEmployee && selectedBoard && (
        <div className="board-side-overlay">
          <div className="board-side-content">

            <button className="board-side-close-btn" onClick={closeDetails}>
              <RiCloseLargeFill />
            </button>

            <h3 className="board-side-popup-header">
              View & Edit Board Member Details
            </h3>

            {/* Photo preview */}
            {editData.photo_url && (
              <img
                src={editData.photo_url}
                alt={editData.full_name}
                className="board-side-popup-img"
              />
            )}

            <div className="board-side-popup-scroll">
              <div className="board-side-popup-details">

                <div className="board-side-popup-row">
                  <label>Full Name:</label>
                  <input
                    type="text"
                    value={editData.full_name}
                    onChange={(e) => handleChange("full_name", e.target.value)}
                  />
                </div>

                <div className="board-side-popup-row">
                  <label>Professional Title:</label>
                  <input
                    type="text"
                    value={editData.professional_title}
                    onChange={(e) => handleChange("professional_title", e.target.value)}
                  />
                </div>

                <div className="board-side-popup-row">
                  <label>Current Position:</label>
                  <input
                    type="text"
                    value={editData.current_position}
                    onChange={(e) => handleChange("current_position", e.target.value)}
                  />
                </div>

                <div className="board-side-popup-row">
                  <label>Photo URL:</label>
                  <input
                    type="text"
                    value={editData.photo_url}
                    onChange={(e) => handleChange("photo_url", e.target.value)}
                  />
                </div>

                <div className="board-side-popup-row">
                  <label>LinkedIn URL:</label>
                  <input
                    type="text"
                    value={editData.linkedin_url}
                    onChange={(e) => handleChange("linkedin_url", e.target.value)}
                  />
                </div>

                <div className="board-side-popup-row">
                  <label>Twitter URL:</label>
                  <input
                    type="text"
                    value={editData.twitter_url}
                    onChange={(e) => handleChange("twitter_url", e.target.value)}
                  />
                </div>

                <div className="board-side-popup-row">
                  <label>Facebook URL:</label>
                  <input
                    type="text"
                    value={editData.facebook_url}
                    onChange={(e) => handleChange("facebook_url", e.target.value)}
                  />
                </div>

              </div>
            </div>

            <button
              className="board-side-save-btn"
              onClick={saveDetails}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </button>

          </div>
        </div>
      )}
    </div>
  );
}

export default Boardmembers;